import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WelcomeQuestion, welcomeQuestions } from './chat-welcome-questions';
import { BreakpointService } from '../../../shared/services/breakpoints.service';

@Component({
  selector: 'app-chat-welcome-container',
  templateUrl: './chat-welcome-container.component.html',
  styleUrls: ['./chat-welcome-container.component.scss'],
})
export class ChatWelcomeContainerComponent {
  @Input() userName: string = '';
  @Output() exampleQuestionSubmitted = new EventEmitter<string>();

  preDefinedQuestions: WelcomeQuestion[] = welcomeQuestions;
  screenSize$ = this.breakpointService.screenSize$;

  constructor(public breakpointService: BreakpointService) {}

  onQuestionClick(question: string) {
    this.exampleQuestionSubmitted.emit(question);
  }
}
